(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(marquee) {
      const track = marquee.querySelector('[data-marquee-track]');
      if (!track) return;

      const speed = parseFloat(marquee.style.getPropertyValue('--marquee-speed')) || 60;

      function recalc() {
        const groups = track.querySelectorAll('[data-marquee-group]');
        const first = groups[0];
        if (!first) return;

        const groupWidth = first.scrollWidth;
        const viewport = marquee.offsetWidth;
        if (groupWidth === 0) { setTimeout(recalc, 100); return; }

        // We need enough groups so 1 group covers viewport plus translation buffer.
        // Formula: N >= ceil(viewport / groupWidth) + 1, minimum 2.
        const needed = Math.max(2, Math.ceil(viewport / groupWidth) + 1);

        // Trim or add clones
        const existing = groups.length;
        if (existing < needed) {
          const template = first.cloneNode(true);
          template.setAttribute('aria-hidden', 'true');
          template.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
          for (let i = existing; i < needed; i++) {
            track.appendChild(template.cloneNode(true));
          }
        } else if (existing > needed) {
          for (let i = existing - 1; i >= needed; i--) {
            groups[i].remove();
          }
        }

        const finalCount = track.querySelectorAll('[data-marquee-group]').length;
        track.style.setProperty('--marquee-groups', finalCount);

        // Duration proportional to one group's width => constant px/s speed
        const duration = groupWidth / speed;
        track.style.setProperty('--marquee-duration', duration + 's');
      }

      recalc();

      let t;
      window.addEventListener('resize', () => {
        clearTimeout(t);
        t = setTimeout(recalc, 150);
      });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(recalc);
      }
    }

    function init() {
      document.querySelectorAll('.announcement-marquee').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
